import riot from 'riot';

import Ext from '../../lib/vendor/ExtCore';
import Chaos from '../../lib/chaos/Chaos';
import Layout from '../../lib/chaos/Layout';
import { Broadcaster } from '../../lib/chaos/Broadcaster';
import Util from '../../lib/chaos/Util';
import Config from '../../lib/chaos/Config';
import Connection from '../../lib/chaos/Connection';

import Overlay from '../Overlay/Overlay';
import NewWindow from '../NewWindow/NewWindow';
import { InitRiot } from '../App/App';

/**
 * Layout handles all the tasks needed to be done before a page start.
 * Parent Class of all the layouts.
 */

export default class PortalLayout extends Layout {
	get properties() {
		return { ...super.properties,
			/** @var {String} linkSel                       Selector of the link elements */
			linkSel : 'a, button',
			/** @var {String} disabledCls                   Disabled class on link elements */
			disabledCls : 'disabled',
			/** @var {String} overlayContentId              Id of the inner overlay content */
			overlayContentCls : 'overlayContent',
			/** @var {String}                               Link elements */
			_linkEls : undefined,
			/** @var {String}                               Main container seelector. */
			mainContainerSel : '#mainContainer',
			/** @var {String}                               Ajax session keep alive route */
			sessionKeepAliveRoute : 'Event/RefreshSession'

		};
	}
	init(el, config) {

		this._linkEls = this.element.select(this.linkSel);
		super.init(el, config);
		new NewWindow(Ext.getBody(), {});
	}

	initSessionKeepAlive() {
		setInterval(::this.sessionKeepAlive, 120 * 1000);
	}

	/**
	 * Keeps the session alive. If the session is lost on server side, it trigger a logout.
	 *
	 * @param scope Scope Of the method.
	 */
	sessionKeepAlive() {
		const url = Chaos.getUrl(
			this.sessionKeepAliveRoute,
			{},
			{ sourceUrl : Util.getUrlWithoutHost() },
			''
		);

		Connection.Ajax.request({
			type    : 'json',
			url     : url,
			scope   : this,
			success : this.sessionKeepAliveSuccess,
			method  : 'get'
		}, 2000);
	}

	/**
	 * Session Keep Alive Ajax Success Method
	 */
	sessionKeepAliveSuccess({ json : { errorCode, data } }) {
		if (errorCode) {
			window.location.href = Config.get('baseUrl');
		}
		else if (!data) {
			window.location.href = data;
		}
	}

	/**
	 * On link click.
	 * Prevent native event if has disabled class.
	 *
	 * @param ev EventObject
	 * @param target Target DOM element
	 */
	onLinkClick(ev, target) {
		var targetEl = Ext.get(target);

		if (targetEl.hasClass(this.disabledCls)) {
			ev.preventDefault();
			ev.stopPropagation();
		}
	}

	/**
	 *
	 * @private
	 */
	_onOverlayReady() {
		var overlayEls = Ext.select(this.overlayContentCls.dot());
		var last = overlayEls.elements.length - 1;
		var overlayEl = overlayEls.item(last);

		this._linkEls = overlayEl.select(this.linkSel);
		this._linkEls.on('click', this.onLinkClick, this);
		InitRiot(overlayEl.dom);
	}

	/**
	 * Esemenykezelok feliratkozasa
	 */
	bind() {
		super.bind();
		this._linkEls.on('click', this.onLinkClick, this);
		Broadcaster.on(Overlay.OVERLAY_READY, this._onOverlayReady, this);
	}

	/**
	 * Esemenykezelok torlese
	 */
	unbind() {
		this.autoUnbind();
	}
}
